<template>
    <div class="card-item" @click="$emit('add-to-cart',product)" v-show="isLoad">
        <img class="card-img-top p-0" :src="url" img-alt="Image" height="100" width="100%" /> 
        <div class="card-title text-center text-truncate" v-b-tooltip :title="product.name">{{product.name}}</div>
        <p class="text-center">{{product.price | numFormat('0,0.00')}} <small>บาท</small> </p>
    </div>
</template>
<script>
export default {
  name: "carditem",
  props:[
    "product" , "disabled"
  ], 
  data() {
    return {
      url: "/img/product/icon_empthy_state.svg" ,
      isLoad: true
    };
  },
  mounted(){
    if( this.product.type == 'DEFAULT' ){
        this.url = require(`../assets/images/service/${this.product.image}`)
    }else{
        this.url = ( this.product.image ) ? this.product.image : "/img/product/icon_empthy_state.svg"
    }
  },
  filters: {
    toFixed: function (price,limit) {
      return price.toFixed(limit);
    }
  },
};
</script>
<style>
    .disabled {
        pointer-events: none;
        opacity: 0.5;
    }
</style>
